import i18n from 'i18next';

/**
 * UI表示向け: 多言語やDynamoDB形式を考慮して、表示可能なテキストを返す
 */
export const getSafeText = (value, lang = i18n.language || 'ja') => {
  if (value === null || value === undefined) return '';

  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  // DynamoDB形式 { S: "..." }
  if (typeof value === 'object') {
    if ('S' in value && typeof value.S === 'string') {
      return value.S;
    }

    // 多言語オブジェクト { ja: '...', en: '...', zh: '...' } または { ja: { S: '...' }, ... }
    const langValue = value[lang];
    const fallbackOrder = ['ja', 'en', 'zh'];

    // 優先順にフォールバック
    for (const fallbackLang of [lang, ...fallbackOrder]) {
      const candidate = value[fallbackLang];
      if (candidate) {
        if (typeof candidate === 'object' && 'S' in candidate) return candidate.S;
        if (typeof candidate === 'string') return candidate;
      }
    }
  }

  return '';
};